import { cards } from "../../game/data";
import type { PlayerState } from "../../game/playerState";

interface Props {
  state: PlayerState;
  update: (mutate: (draft: PlayerState) => void) => void;
}

export function CardsPanel({ state, update }: Props) {
  const set = (id: string, level: number) =>
    update((draft) => {
      draft.cards[id] = Math.max(0, Math.min(7, level));
    });

  return (
    <div className="panel">
      <div className="card-grid">
        {cards.map((card) => {
          const level = state.cards[card.id] ?? 0;
          const maxed = level >= 7;
          return (
            <div
              key={card.id}
              className={`game-card rarity-${card.rarity}${level > 0 ? " owned" : ""}`}
              title={`${card.description}\nL${level}: ${level > 0 ? card.levels[level - 1] : "not owned"}`}
            >
              <span className="game-card-name">{card.name}</span>
              <span className="game-card-stars">
                {"★".repeat(level)}
                {"☆".repeat(7 - level)}
              </span>
              <span className="game-card-value">{level > 0 ? card.levels[level - 1] : "—"}</span>
              <span className="game-card-controls">
                <button
                  aria-label={`decrease ${card.name}`}
                  disabled={level <= 0}
                  onClick={() => set(card.id, level - 1)}
                >
                  −
                </button>
                <button
                  aria-label={`increase ${card.name}`}
                  disabled={maxed}
                  onClick={() => set(card.id, level + 1)}
                >
                  +
                </button>
                <button
                  className="game-card-max"
                  aria-label={`max ${card.name}`}
                  disabled={maxed}
                  onClick={() => set(card.id, 7)}
                >
                  MAX
                </button>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
